import * as contact from '~web/i18n/english/contact.en.i18n.json';
import * as core from '~web/i18n/english/core.en.i18n.json';
import * as customEvent from '~web/i18n/english/custom-event.en.i18n.json';
import * as discover from '~web/i18n/english/discover.en.i18n.json';
import * as error from '~web/i18n/english/error.en.i18n.json';
import * as event from '~web/i18n/english/event.en.i18n.json';
import * as form from '~web/i18n/english/form.en.i18n.json';
import * as login from '~web/i18n/english/login.en.i18n.json';
import * as menu from '~web/i18n/english/menu.en.i18n.json';
import * as meta from '~web/i18n/english/meta.en.i18n.json';
import * as myYoop from '~web/i18n/english/my-yoop.en.i18n.json';
import * as profile from '~web/i18n/english/profile.en.i18n.json';
import * as promoter from '~web/i18n/english/promoter.en.i18n.json';
import * as seating from '~web/i18n/english/seating.en.i18n.json';
import * as staticPages from '~web/i18n/english/static-pages.en.i18n.json';
import * as streaming from '~web/i18n/english/streaming.en.i18n.json';
import * as token from '~web/i18n/english/token.en.i18n.json';
import * as transaction from '~web/i18n/english/transaction.en.i18n.json';

export const english = {
  ...core,
  ...contact,
  ...customEvent,
  ...discover,
  ...error,
  ...event,
  ...form,
  ...login,
  ...menu,
  ...meta,
  ...myYoop,
  ...profile,
  ...promoter,
  ...seating,
  ...staticPages,
  ...streaming,
  ...transaction,
  ...token,
};



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/i18n/english.ts